import { useAccountRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetAccountsCommonInfoQuery } from "../../features/accounting/accountAPi";

export { useAccountRoutes };

export default GetDefaultIndex({
  title: "حساب‌های کاربری",
  query: useGetAccountsCommonInfoQuery,
});
